<template>
  <div
    class="cpt-multi-compilation"
    :style="cptStyle"
    ref="block"
  >
    <div class="tab-list-container" :style="tabListStyle">
      <div class="tab-list-wrapper">
        <div class="tab-list">
          <div 
            class="tab-item"
            ref="tab-item"
            v-for="(tab, index) in cd.multi_compilation"
            :class="{active: activeIndex === index}"
            :style="{color: activeIndex === index ? cc.tab_color : cc.tab_unselected_color}"
            @click="changeTab(index, true)"
            :key="index"
          >{{ tab.name }}</div>
          <div class="active-bar" :style="[{background: cc.tab_color}, activeBarStyle]"></div>
        </div>
      </div>
    </div>
    <div class="game-list-container" ref="game-list-container">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="(list, index) in cd.multi_compilation" :key="index">
          <div
            class="game-item"
            v-for="game, _index in list.games"
            @click="toGameDetail(game)"
            :key="(game.appid || game.steam_appid) + _index"
            v-report.exposure="getReportConfig(game)"
          >
            <div class="game-img">
              <img v-src="game.image" @error.once="(e) => gameImgError(e, game)" alt="">
              <div class="tag" v-if="game.label" :style="{background: imgTagBg}">{{ game.label }}</div>
            </div>
            <div class="game-info">
              <p class="game-name" :style="{color: cc.game_name_color}">{{ game.name }}</p>
              <div class="game-labels">
                <div class="label-list">
                  <div
                    class="label"
                    v-for="label in game.combine_labels"
                    :style="{
                      color: label.high_light ? cc.tag_light_text_color : cc.tag_text_color,
                      background: label.high_light ? cc.tag_light_bg_color : cc.tag_bg_color
                    }"
                  >{{ label.desc }}</div>
                </div>
              </div>
              <div class="btn" :style="{background: cc.btn_img ? `right / auto 100% url(${cc.btn_img}) no-repeat, ${cc.btn_bg_color}` : cc.btn_bg_color}">
                <div class="price-info">
                  <div class="current" :style="{color: cc.price_color}" v-if="hasHeyboxPrice(game)">
                    <span class="unit">￥</span><span class="num">{{ Math.ceil(game.heybox_price.cost_coin / 1000) }}</span>
                  </div>
                  <div class="original" :style="{color: cc.price_origin_color}" v-if="hasHeyboxPrice(game)">
                    <span class="unit">￥</span><span class="num">{{ Math.ceil(game.heybox_price.original_coin / 1000) }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="bottom-img" v-if="cc.bottom_img">
            <img v-src="cc.bottom_img" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ComponentCommonMixin } from '../mixin'
import { executeProtocol } from '_lib/utils'
import { getCompilationData } from '_api/activity/activity-common-template'
import Swiper from 'swiper'
import 'swiper/swiper-bundle.css'

export default {
  name: 'cpt-multi-compilation',
  mixins: [ComponentCommonMixin],
  data () {
    return {
      activeBarStyle: {
        left: '0px',
        width: '0px'
      },
      nav_height: this.gd.nav_height,
      activeIndex: -1,
      tabListStyle: {},
      page_info: {},
      game_id: {}
    }
  },
  computed: {
    cptStyle () {
      let config = {
        'margin-top': this.cc.margin_top + 'px' || this.gc.margin_top + 'px',
        'margin-bottom': this.cc.margin_bot + 'px' || this.gc.margin_bot + 'px',
        'background': this.cc.bg_color || '#FFFFFF'
      }
      return config
    },
    imgTagBg () {
      const colors = this.cc.img_tag_bg_color.split(',')
      if (colors.length === 1) return colors[0]
      return `linear-gradient(45deg, ${colors[0]} 0%, ${colors[1]} 100%)`
    }
  },
  mounted () {
    this.setSwiper()
    this.handleCeiling()
    this.handleLoading()
    this.changeTab(0)
    this.initSet()
  },
  beforeDestroy () {
    this.cancelCeilingListener()
    this.cancelLoadingListener()
  },
  methods: {
    // 初始化数据缓存id在game_id_set里面
    initSet() {
      let { multi_compilation } = this.cd
      multi_compilation?.forEach((compilation, i) => {
          if( !this.game_id[i] ) this.game_id[i] = new Set();
          compilation.games.forEach(item => {
            this.game_id[i].add(item.appid);
          })
      })
    },
    async getData () {
      if (this.get_data_lock || this.page_info.no_more) return
      this.get_data_lock = true
      let current = this.cd.multi_compilation[this.swiper.realIndex];
      const {data: {result: {games}, status}} = await getCompilationData({
        ...this.page_info,
        cpl_id: current.id,
        act_id: this.querys.act_id
      })
      if (status != 'ok') {
        this.get_data_lock = false
        return
      }
      if (!games) {
        this.page_info.no_more = true
        this.get_data_lock = false
        return
      }
       games.forEach( item => {
          const appid = item.appid;
          if( !this.game_id[this.swiper.realIndex].has(appid)) {
             this.game_id[this.swiper.realIndex].add(appid);
             current.games.push(item);
          }
       })
       
      this.page_info.offset += this.page_info.limit;
      if (games.length == 0) {
        this.page_info.no_more = true
      } 
      setTimeout(() => {
        this.swiper.updateAutoHeight()
      })
      this.get_data_lock = false
    },
    changeTab (index, scroll) {
      if (this.activeIndex === index || this.scroll_lock) return
      this.activeIndex = index
      this.togglePageInfo(index)
      if (scroll) {
        window.scrollTo({
          top: this.$refs['block'].offsetTop - this.nav_height + 5
        })
      }
      this.$nextTick(() => {
        const barWidth = this.$refs['tab-item'][index].offsetWidth
        const barLeft = this.$refs['tab-item'][index].offsetLeft
        this.activeBarStyle.left = barLeft + 'px'
        this.activeBarStyle.width = barWidth + 'px'
        window.HeyboxReport && (window.HeyboxReport.isScroll = true)
        this.easeOutScrollToX(barLeft - Math.min(window.innerWidth, 480) / 2 + barWidth / 2).then(() => {
          window.HeyboxReport && (window.HeyboxReport.isScroll = false)
        })
        this.swiper.slideTo(index)
      })
    },
    togglePageInfo: (() => {
      let pages_info = {}
      return function (index) {
        if (!pages_info[index]) {
          let current = this.cd.multi_compilation[index]
          pages_info[index] = {
            limit: 30,
            offset: 0,
            no_more: current.game_count.length == current.games.length
          }
          this.page_info = pages_info[index]
          this.getData()
        } else {
          this.page_info = pages_info[index]
        }
      }
    })(),
    handleCeiling () {
      const callback = (e) => {
        let { top } = this.$refs.block.getBoundingClientRect()
        if (top <= this.nav_height) {
          this.tabListStyle = {
            position: "fixed",
            top: this.nav_height + 'px',
            left: 0,
            background: this.cc.bg_color || '#FFFFFF'
          }
        } else {
          this.tabListStyle = {}
        }
      }
      window.addEventListener("scroll", callback)
      this.cancelCeilingListener = () => {
        window.removeEventListener("scroll", callback)
      }
    },
    handleLoading () {
      const callback = (e) => {
        let active = this.swiper.slides[this.swiper.realIndex]
        let {bottom} = active.getBoundingClientRect()
        if (bottom < window.innerHeight + 400) {
          this.getData()
        }
      }
      window.addEventListener("scroll", callback)
      this.cancelLoadingListener = () => {
        window.removeEventListener("scroll", callback)
      }
    },
    setSwiper () {
      const _this = this
      let swiperOption = {
        observer: true,
        observeParents: true,
        autoHeight: true,
        edgeSwipeDetection : true,
        edgeSwipeThreshold: 20,
        allowTouchMove: false,
        speed: 0,
        on: {
          slideChange (swiper) {
            _this.changeTab(swiper.activeIndex)
          }
        }
      }
      this.swiper = new Swiper(this.$refs['game-list-container'], swiperOption)
    },
    easeOutScrollToX (position = 0) {
      return new Promise(resolve => {
        this.scroll_lock = true
        // 不存在原生requestAnimationFrame，用setTimeout模拟替代
        const el = document.querySelector('.tab-list-wrapper')
        if (!window.requestAnimationFrame) {
          window.requestAnimationFrame = function (cb) {
            return setTimeout(cb, 17);
          }
        }
        // 当前滚动高度
        var scrollLeft = el.scrollLeft
        const step =  () => {
          const distance = position - scrollLeft
          scrollLeft = scrollLeft + distance / 5
          if (Math.abs(distance) < 1) {
            el.scrollTo(position, 0)
            setTimeout(() => {
              this.scroll_lock = false
              resolve()
            }, 18)
          } else {
            el.scrollTo(scrollLeft, 0)
            requestAnimationFrame(step)
          }
        }
        step()
      })
    },
    getReportConfig (game) {
      return {
        path: '/game/item/show',
        type: '3',
        addition: {
          app_id: game.appid || game.steam_appid,
          act_id: this.act_id || this.querys.act_id,
          h_src: window.btoa('h5_game_edition_list_' + (this.act_id || this.querys.act_id))
        }
      }
    },
    toGameDetail (game) {
      if (!this.is_in_heybox) {
        this.openInHeybox()
        return
      }
      executeProtocol({
        protocol_type: 'openGameDetail', // 协议类型
        app_id: game.appid, // 必须，游戏ID
        game_type: game.game_type, //必须，iOS 1.1.22新增
        sku_id: game.sku_id,
        h_src: window.btoa('h5_game_edition_list_' + (this.act_id || this.querys.act_id))
      })
    },
    hasHeyboxPrice (game) {
      return game.heybox_price && Object.keys(game.heybox_price).length > 0
    },
    gameImgError (e, game) {
      // 有的游戏没有616x353尺寸的图片，用header代替
      const header_img = game.image.replace('capsule_616x353', 'header')
      e.target.src = header_img
    },
  }
}
</script>

<style lang="less" scoped>
.cpt-multi-compilation {
  position: relative;
  width: 100%;
  padding-top: 43px;
  border-radius: 5px 5px 0 0;
  background: #FFF;
  // overflow: hidden;
  .tab-list-container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 43px;
    border-radius: 5px 5px 0 0;
    overflow: hidden;
    z-index: 20;
    .tab-list-wrapper {
      display: flex;
      width: 100%;
      height: 73px;
      padding-bottom: 30px;
      overflow-x: auto;
      overflow-y: hidden;
      .tab-list {
        display: flex;
        align-items: center;
        position: relative;
        flex-shrink: 0;
        height: 43px;
        padding: 0 12px;
        .tab-item {
          flex-shrink: 0;
          height: 20px;
          color: #64696E;
          font-size: 13px;
          line-height: 20px;
          &.active {
            font-size: 14px;
            font-weight: 600;
            line-height: 20px;
            color: #14191E;
          }
          &:not(:first-of-type) {
            margin-left: 20px;
          }
        }
        .active-bar {
          position: absolute;
          left: 12px;
          bottom: 0;
          width: 56px;
          height: 2px;
          border-radius: 1px;
          background: #14191E;
          transition: all .2s ease-in-out;
        }
      }
    }
  }
  .game-list-container {
    width: 100%;
    .swiper-wrapper {
      // min-height: 498px;
      .swiper-slide {
        padding: 10px 12px 0;
        .game-item {
          display: flex;
          align-items: center;
          width: 100%;
          &:not(:first-of-type) {
            margin-top: 12px;
          }
          .game-img {
            position: relative;
            width: 158px;
            height: 90px;
            border-radius: 5px;
            overflow: hidden;
            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
            .tag {
              position: absolute;
              left: 0;
              bottom: 0;
              height: 30px;
              padding: 2px 8px;
              border-radius: 6px;
              background: linear-gradient(45deg, #FF6771 0%, #F53E59 100%);
              color: #FFFFFF;
              font-size: 18px;
              font-weight: 500;
              line-height: 26px;
              transform: scale(0.5);
              transform-origin: left bottom;
            }
          }
          .game-info {
            display: flex;
            flex-direction: column;
            justify-content: center;
            width: 0;
            flex: 1;
            height: 100%;
            margin-left: 8px;
            .game-name {
              color: #14191E;
              font-family: PingFang SC;
              font-size: 14px;
              font-weight: 500;
              line-height: 20px;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
            }
            .game-labels {
              position: relative;
              width: 100%;
              height: 16px;
              overflow: hidden;
              margin-top: 4px;
              .label-list {
                position: absolute;
                left: 0;
                top: 0;
                width: 200%;
                display: flex;
                align-items: center;
                flex-wrap: wrap;
                transform: scale(0.5);
                transform-origin: left top;
                .label {
                  padding: 6px;
                  border-radius: 4px;
                  background: #F3F4F5;
                  color: #8C9196;
                  text-align: center;
                  font-size: 18px;
                  line-height: 20px;
                  white-space: nowrap;
                  &:not(:first-of-type) {
                    margin-left: 8px;
                  }
                }
              }
            }
            .btn {
              display: flex;
              align-items: center;
              width: 100%;
              height: 32px;
              border-radius: 4px;
              padding: 0 15px 0 8px;
              margin-top: 8px;
              .price-info {
                display: flex;
                align-items: flex-end;
                height: 20px;
                .current {
                  display: flex;
                  align-items: flex-end;
                  color: #FA3C4B;
                  .unit {
                    font-size: 12px;
                    font-weight: 600;
                    line-height: 16px;
                  }
                  .num {
                    font-family: Helvetica;
                    font-size: 17px;
                    font-weight: 700;
                    line-height: 17px;
                  }
                }
                .original {
                  display: flex;
                  align-items: center;
                  transform: scale(0.5);
                  transform-origin: left bottom;
                  white-space: nowrap;
                  margin-left: 3px;
                  color: rgba(0, 0, 0, 0.40);
                  .unit {
                    font-size: 18px;
                    line-height: 30px;
                    text-decoration-line: line-through;
                  }
                  .num {
                    font-family: Helvetica;
                    font-size: 20px;
                    line-height: 22px;
                    text-decoration-line: line-through;
                  }
                }
              }
            }
          }
        }
        .bottom-img {
          width: 100%;
          height: auto;
          img {
            width: 100%;
            height: auto;
          }
        }
      }
    }
  }
}
</style>